import { LEGAL_DOC_URL, LegalDocumentDataType } from '@oy/types';
import { getLegalDocumentById } from 'src/clients';
import { useCheckMAMViewOnlyChildType, useUserRole } from 'src/hooks';
import useSWR from 'swr';

export const useSignLegalDocumentByIdData = (
  legalDocs: LegalDocumentDataType[],
  activeIndex: number,
) => {
  const { isViewOnlyChildActive } = useCheckMAMViewOnlyChildType();
  const { isSuperAdmin } = useUserRole();

  const fetchDocument = async () => {
    const response = await getLegalDocumentById(legalDocs[activeIndex].id);
    if (response.data.success && response.data?.data) {
      return `data:application/pdf;base64,${response.data.data?.file}`;
    }
  };

  const { data = '', ...swr } = useSWR(
    isViewOnlyChildActive || !isSuperAdmin || legalDocs.length < 1
      ? null
      : [LEGAL_DOC_URL, activeIndex],
    () => fetchDocument(),
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      revalidateOnMount: true,
      errorRetryCount: 2,
    },
  );

  return { data, ...swr };
};
